const onlineExamStrings={
    title:'onlineExam.title'
}

export const stringFiles={
    common:'common',
}

export const commonStrigns={
    retry:'global.retry',
    serverError:'global.serverError',
    error:'global.error',
    cancel:'global.cancel'
}

export const onlineExamString={
    header:'onlineExam.header',
   planTab:'onlineExam.planTab',
   resultTab:'onlineExam.resultTab',
   examTitle:'onlineExam.onlineExamTitle',
   download:'onlineExam.download',
   duration:'onlineExam.duration',
   average:'onlineExam.average',
   rank:'onlineExam.rank',
   courseName:'onlineExam.courseName',
   description:'onlineExam.description',
   questionsCount:'onlineExam.questionsCount',
   timeToFinishExam:'onlineExam.timeToFinishExam',
   start:'onlineExam.start',
   examStartQuestion:'onlineExam.examStartQuestion',
   examStartInfoQuestion:'onlineExam.examStartInfoQuestion',
   examStartInfoTwoQuestion:'onlineExam.examStartInfoTwoQuestion',
   listFinish:'onlineExam.listFinish',
   subject:'onlineExam.subject',
   endAt:'onlineExam.endAt',
   startAt:'onlineExamResult.startAt',
   examNotFinished:'onlineExam.examNotFinished',


}
export const assessmentString={
    header:'assessment.header',
   planTab:'assessment.planTab',
   resultTab:'assessment.resultTab',
   assessmentTitle:'assessment.assessmentTitle',
   duration:'assessment.duration',
   average:'assessment.average',
   rank:'assessment.rank',
   courseName:'assessment.courseName',
   description:'assessment.description',
   questionsCount:'assessment.questionsCount',
   timeToFinishAssessment:'assessment.timeToFinishAssessment',
   start:'assessment.start',
   assessmentStartQuestion:'assessment.assessmentStartQuestion',
   assessmentStartInfoQuestion:'assessment.assessmentStartInfoQuestion',
   assessmentStartInfoTwoQuestion:'assessment.assessmentStartInfoTwoQuestion',
   listFinish:'assessment.listFinish',
   subject:'assessment.subject',
   endAt:'assessment.endAt',
   startAt:'assessmentResult.startAt',
   assessmentNotFinished:'assessment.assessmentNotFinished',


}


export const assignmentString={
    header:'assignment.header',
   planTab:'assignment.planTab',
   resultTab:'assignment.resultTab',
   assignmentTitle:'assignment.assignmentTitle',
   duration:'assignment.duration',
   average:'assignment.average',
   rank:'assignment.rank',
   courseName:'assignment.courseName',
   description:'assignment.description',
   questionsCount:'assignment.questionsCount',
   timeToFinishExam:'assignment.timeToFinishExam',
   start:'assignment.start',
   assignmentStartQuestion:'assignment.assignmentStartQuestion',
   assignmentStartInfoQuestion:'assignment.assignmentStartInfoQuestion',
   assignmentStartInfoTwoQuestion:'assignment.assignmentStartInfoTwoQuestion',
   listFinish:'assignment.listFinish',
   subject:'assignment.subject',
   endAt:'assignment.endAt',
   startAt:'assignmentResult.startAt',
   assignmentNotFinished:'assignment.assignmentNotFinished',


}

export const onlineExamDetailString={
    header:'onlineExamDetail.header',
    finishPopUpTitle:'onlineExamDetail.finishPopUpTitle',
    finishPopUpQuestion:'onlineExamDetail.finishPopUpQuestion',
    finishPopUpSubmit:'onlineExamDetail.finishPopUpSubmit',
    finishPopUpCancel:'onlineExamDetail.finishPopUpCancel',
    settingPopUpTitle:'onlineExamDetail.settingPopUpTitle',
    finishTwoPopUpTitle:'onlineExamDetail.finishTwoPopUpTitle',
    settingPopUpOptionOne:'onlineExamDetail.settingPopUpOptionOne',
    settingPopUpSubmit:'onlineExamDetail.settingPopUpSubmit',
    settingPopUpCancel:'onlineExamDetail.settingPopUpCancel',
    questionCount:'onlineExamDetail.questionCount',
    examDuration:'onlineExamDetail.examDuration',
    setting:'onlineExamDetail.setting',
    finish:'onlineExamDetail.finish',
    question:'onlineExamDetail.question',
    answer:'onlineExamDetail.answer',
    questions:'onlineExamDetail.questions',
    viewQuestions:'onlineExamDetail.viewQuestions',
    withoutAnswer:'onlineExamDetail.withoutAnswer',
    yourAnswer:'onlineExamDetail.yourAnswer',
    showNextQuestion:'onlineExamDetail.showNextQuestion',
    previousQuestion:'onlineExamDetail.previousQuestion',
    nextQuestion:'onlineExamDetail.nextQuestion',
    showQuestion:'onlineExamDetail.showQuestion',
    submit:'onlineExamDetail.submit',

}
export const assignmentDetailString={
    header:'assignmentDetail.header',
    finishPopUpTitle:'assignmentDetail.finishPopUpTitle',
    finishPopUpQuestion:'assignmentDetail.finishPopUpQuestion',
    finishPopUpSubmit:'assignmentDetail.finishPopUpSubmit',
    finishPopUpCancel:'assignmentDetail.finishPopUpCancel',
    settingPopUpTitle:'assignmentDetail.settingPopUpTitle',
    settingPopUpOptionOne:'assignmentDetail.settingPopUpOptionOne',
    settingPopUpSubmit:'assignmentDetail.settingPopUpSubmit',
    settingPopUpCancel:'assignmentDetail.settingPopUpCancel',
    questionCount:'assignmentDetail.questionCount',
    examDuration:'assignmentDetail.examDuration',
    setting:'assignmentDetail.setting',
    finish:'assignmentDetail.finish',
    question:'assignmentDetail.question',
    answer:'assignmentDetail.answer',
    questions:'assignmentDetail.questions',
    viewQuestions:'assignmentDetail.viewQuestions',
    withoutAnswer:'assignmentDetail.withoutAnswer',
    yourAnswer:'assignmentDetail.yourAnswer',
    showNextQuestion:'assignmentDetail.showNextQuestion',
    previousQuestion:'assignmentDetail.previousQuestion',
    nextQuestion:'assignmentDetail.nextQuestion',
    showQuestion:'assignmentDetail.showQuestion',
    submit:'assignmentDetail.submit',

}

export const onlineExamResultString={
    header:'onlineExamResult.header',
    average:'onlineExamResult.average',
    yourGrade:'onlineExamResult.yourGrade',
    questionsCount:'onlineExamResult.questionsCount',
    correctAnswer:'onlineExamResult.correctAnswer',
    wrongAnswer:'onlineExamResult.wrongAnswer',
    percents:'onlineExamResult.percents',
    percentsAverage:'onlineExamResult.percentsAverage',
    withoutAnswer:'onlineExamResult.withoutAnswer',
    schoolRank:'onlineExamResult.schoolRank',
    classRank:'onlineExamResult.classRank',
    from:'onlineExamResult.from',
    person:'onlineExamResult.person',
    showQuestions:'onlineExamResult.showQuestions',
    course:'onlineExamResult.course',
    subject:'onlineExamResult.subject',
    startAt:'onlineExamResult.startAt',
    endAt:'onlineExamResult.endAt',
    grade:'onlineExamResult.grade',
    dontShowResponseToParent:'onlineExamResult.dontShowResponseToParent',
    viewResult:'onlineExamResult.viewResult',
    examNotJoin:'onlineExamResult.examNotJoin',
    examNotFinished:'onlineExamResult.examNotFinished',

}
export const assessmentResultString={
    header:'assessmentResult.header',
    average:'assessmentResult.average',
    yourGrade:'assessmentResult.yourGrade',
    questionsCount:'assessmentResult.questionsCount',
    correctAnswer:'assessmentResult.correctAnswer',
    wrongAnswer:'assessmentResult.wrongAnswer',
    percents:'assessmentResult.percents',
    percentsAverage:'assessmentResult.percentsAverage',
    withoutAnswer:'assessmentResult.withoutAnswer',
    schoolRank:'assessmentResult.schoolRank',
    classRank:'assessmentResult.classRank',
    from:'assessmentResult.from',
    person:'assessmentResult.person',
    showQuestions:'assessmentResult.showQuestions',
    course:'assessmentResult.course',
    subject:'assessmentResult.subject',
    startAt:'assessmentResult.startAt',
    endAt:'assessmentResult.endAt',
    grade:'assessmentResult.grade',
    dontShowResponseToParent:'assessmentResult.dontShowResponseToParent',
    viewResult:'assessmentResult.viewResult',
    assessmentNotJoin:'assessmentResult.assessmentNotJoin',
    assessmentNotFinished:'assessmentResult.assessmentNotFinished',
    assessmentNotSend:'assessmentResult.assessmentNotSend',

}
export const assignmentResultString={
    header:'assignmentResult.header',
    average:'assignmentResult.average',
    yourGrade:'assignmentResult.yourGrade',
    questionsCount:'assignmentResult.questionsCount',
    correctAnswer:'assignmentResult.correctAnswer',
    wrongAnswer:'assignmentResult.wrongAnswer',
    percents:'assignmentResult.percents',
    percentsAverage:'assignmentResult.percentsAverage',
    withoutAnswer:'assignmentResult.withoutAnswer',
    schoolRank:'assignmentResult.schoolRank',
    classRank:'assignmentResult.classRank',
    from:'assignmentResult.from',
    person:'assignmentResult.person',
    showQuestions:'assignmentResult.showQuestions',
    course:'assignmentResult.course',
    subject:'assignmentResult.subject',
    startAt:'assignmentResult.startAt',
    endAt:'assignmentResult.endAt',
    grade:'assignmentResult.grade',
    dontShowResponseToParent:'assignmentResult.dontShowResponseToParent',
    viewResult:'assignmentResult.viewResult',
    assignmentNotJoin:'assignmentResult.assignmentNotJoin',
    assignmentNotFinished:'assignmentResult.assignmentNotFinished',

}